// extracted by mini-css-extract-plugin
export default {"editButton":"cashAllowance_editButton__5lVZI","TableBody":"cashAllowance_TableBody__W16JA"};